import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export function scoreTone(score: number | null | undefined) {
  if (score === null || score === undefined)
    return { text: 'text-ink-400', bg: 'bg-ink-200', ring: 'stroke-ink-300', hex: '#a8a29e' };
  if (score >= 90)
    return {
      text: 'text-emerald-700',
      bg: 'bg-emerald-600',
      ring: 'stroke-emerald-600',
      hex: '#059669',
    };
  if (score >= 70)
    return { text: 'text-lime-700', bg: 'bg-lime-600', ring: 'stroke-lime-600', hex: '#65a30d' };
  if (score >= 50)
    return { text: 'text-amber-700', bg: 'bg-amber-500', ring: 'stroke-amber-500', hex: '#f59e0b' };
  return { text: 'text-red-700', bg: 'bg-red-600', ring: 'stroke-red-600', hex: '#dc2626' };
}

export const formatDate = (iso?: string) =>
  iso
    ? new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(
        new Date(iso),
      )
    : '';

export const hostOf = (url: string) => {
  try {
    return new URL(url).host.replace(/^www\./, '');
  } catch {
    return url;
  }
};
